import { SEARCH_KEYS } from './query-params/search';

export enum ELASTIC_SEARCH_ALGORITHMS {
    DEFAULT = 7,
    PRICE_RANKING = 27,
    LTR_1_1 = 31,
    LTR_1_2 = 34,
    LTR_1_3 = 36
}

export enum SEARCH_PAGES {
    MAIN = 'main',
    AUTHOR = 'author'
}

export enum MATERIAL_VIEWS {
    GRID = 'grid',
    LIST = 'list',
    MOBILE = 'mobile'
}

export enum PRICE_FILTER_IDS {
    FREE = 3,
    LESS_THAN_2 = 0,
    FROM_2_TO_5 = 1,
    MORE_THAN_5 = 2
}

export enum FORMAT_FILTER_IDS {
    DOWNLOADABLE = 1,
    INTERACTIVE = 0,
    INTERACTIVE_SELF_CREATED = 2,
    INTERACTIVE_PURCHASED_CUSTOMIZED = 3,
    INTERACTIVE_PURCHASED = 4,
    INTERACTIVE_STANDALONE = 5,
    INTERACTIVE_HYBRID = 6
}

export enum OWNED_BY {
    ME = 2,
    SCHOOL = 1
}

export enum TOTAL_PAGES_IDS {
    LESS_THAN_5 = 0,
    FROM_5_TO_20 = 1,
    MORE_THAN_20 = 2
}

export const MULTIPLE_SELECTION_FILTERS: string[] = [
    SEARCH_KEYS.PRICE,
    SEARCH_KEYS.FORMAT,
    SEARCH_KEYS.OWNED_BY,
    SEARCH_KEYS.CLASS_GRADES,
    SEARCH_KEYS.MATERIAL_TYPES,
    SEARCH_KEYS.INTERACTIVE_TYPES,
    SEARCH_KEYS.FILE_TYPES,
    SEARCH_KEYS.SCHOOL_TYPES,
    SEARCH_KEYS.LEARNING_YEARS,
    SEARCH_KEYS.TOTAL_PAGES,
    SEARCH_KEYS.SALE,
    SEARCH_KEYS.TAGS,
    SEARCH_KEYS.BUNDLE,
    SEARCH_KEYS.LANGUAGES
];

export const NON_FILTER_KEYS: string[] = [
    SEARCH_KEYS.QUERY,
    SEARCH_KEYS.PAGE,
    SEARCH_KEYS.SORTING,
    SEARCH_KEYS.FOLDER,
    SEARCH_KEYS.PREVENT_AUTOSUGGEST
];

export type DefaultFiltersStateType = {
    file_types: Filter[];
    format: Filter[];
    price: Filter[];
    school_types: Filter[];
    high_quality: Filter[];
    tags: Filter[];
    class_grade: Filter[];
    learning_years: Filter[];
    material_type: Filter[];
    ownedBy: Filter[];
    bundle: Filter[];
    taxonomyFilters: TaxonomyFilter[];
    taxonomyParents: TaxonomyFilter[];
    total_pages: number[];
};

export const DEFAULT_FILTERS_STATE: DefaultFiltersStateType = {
    class_grade: [],
    file_types: [],
    format: [],
    learning_years: [],
    material_type: [],
    price: [],
    bundle: [],
    school_types: [],
    high_quality: [],
    tags: [],
    taxonomyFilters: [],
    taxonomyParents: [],
    total_pages: [],
    ownedBy: []
};
